webpackJsonp([111487850492888],{

/***/ 647:
/***/ (function(module, exports) {

	module.exports = "App\\Entity\\Actor:\n    actor{1..10}:\n      name: '<name()>'\n      picture: '<image(\"./public/images\", 500, 500, \"people\", 0)>'"

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

	module.exports = "App\\Entity\\Movie:\n    movie{1..10}:\n      name: '<sentence(4, true)>'\n      director: '<name()>'\n      year: '<numberBetween(1970, 2017)>'\n      picture: '<image(\"./public/images\", 500, 500, \"cats\", 0)>'"

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

	module.exports = "App\\Entity\\Movie:\n    movie{1..10}:\n      name: '<sentence(4, true)>'\n      director: '<name()>'\n      year: '<numberBetween(1970, 2017)>'\n      picture: '<image(\"./public/images\", 500, 500, \"cats\", 0)>'\n      actors: [\"@actor<numberBetween(1, 3)>\", \"@actor<numberBetween(4, 6)>\", \"@actor<numberBetween(7, 10)>\"]"

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(9);
	
	var _Heading = __webpack_require__(14);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Exercise = __webpack_require__(25);
	
	var _Exercise2 = _interopRequireDefault(_Exercise);
	
	var _Theory = __webpack_require__(26);
	
	var _Theory2 = _interopRequireDefault(_Theory);
	
	var _Tip = __webpack_require__(59);
	
	var _Tip2 = _interopRequireDefault(_Tip);
	
	var _P = __webpack_require__(15);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _Command = __webpack_require__(24);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _SH = __webpack_require__(16);
	
	var _SH2 = _interopRequireDefault(_SH);
	
	var _Toc = __webpack_require__(20);
	
	var _Toc2 = _interopRequireDefault(_Toc);
	
	var _ButtonLink = __webpack_require__(13);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Toc2.default, { active: "fixtures" }),
	    _react2.default.createElement(
	      _Heading2.default,
	      { fontSize: 5 },
	      "Fixtures with Alice"
	    ),
	    _react2.default.createElement(
	      _Theory2.default,
	      null,
	      _react2.default.createElement(
	        _P2.default,
	        null,
	        "Some words about Fixtures."
	      )
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "We would like to write now a Controller and a View to see the movies and actors we have in the database. But we have a problem, we don't have movies or actors in our database."
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "It is very convenient to be able to generate some dummy data to populate the database at any time in our development (and testing) environments. We call these dummy data fixtures."
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Let's create some fixtures. Run this command:"
	    ),
	    _react2.default.createElement(
	      _Command2.default,
	      null,
	      "composer require --dev hautelook/alice-bundle"
	    ),
	    _react2.default.createElement(
	      _Tip2.default,
	      null,
	      _react2.default.createElement(
	        _P2.default,
	        null,
	        "This recipe is in the ",
	        _react2.default.createElement(
	          _rebass.Code,
	          null,
	          "contrib"
	        ),
	        " repository that is maintained by the community, so you must agree on use community maintained packages to install it."
	      )
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Alice allows us to write our fixtures in a much more convenient way, and have access to a lot of generators of fake data."
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Let's try writing some fixtures. Open ",
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        "fixtures/movies.yml"
	      ),
	      " ",
	      "with your editor and write this:"
	    ),
	    _react2.default.createElement(_SH2.default, { code: __webpack_require__(648) }),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Create the directory ",
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        "public/images"
	      ),
	      ". and run:"
	    ),
	    _react2.default.createElement(
	      _Command2.default,
	      null,
	      "php bin/console hautelook:fixtures:load"
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Examine the table ",
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        "movies"
	      ),
	      ", and the contents of",
	      " ",
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        "public/images"
	      ),
	      "."
	    ),
	    _react2.default.createElement(
	      _Exercise2.default,
	      {
	        language: "yaml",
	        code: __webpack_require__(647)
	      },
	      _react2.default.createElement(
	        _P2.default,
	        null,
	        "Can you write fixtures for the Entity Actor?"
	      ),
	      _react2.default.createElement(
	        _P2.default,
	        null,
	        "You can do it in the same file ",
	        _react2.default.createElement(
	          _rebass.Code,
	          null,
	          "fixtures/movies.yml"
	        )
	      ),
	      _react2.default.createElement(
	        _P2.default,
	        null,
	        "It should match the properties of our entity (name, picture). At this step, forget about the relationship with movies."
	      ),
	      _react2.default.createElement(
	        _P2.default,
	        null,
	        "Can you make images be about people instead of cats? Try a different category in http://lorempixel.com/"
	      )
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "What about the relationship between movies and actors?"
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Just add a line to the movie fixtures:"
	    ),
	    _react2.default.createElement(_SH2.default, {
	      language: "yaml",
	      code: __webpack_require__(649)
	    }),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "And reload the fixtures:"
	    ),
	    _react2.default.createElement(
	      _Command2.default,
	      null,
	      "php bin/console hautelook:fixtures:load"
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "In our database the tables ",
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        "actor"
	      ),
	      " and ",
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        "movie_actor"
	      ),
	      " ",
	      "are now populated."
	    ),
	    _react2.default.createElement(_ButtonLink2.default, { to: "/controllertemplate", title: "Go to next section" })
	  );
	}; /* eslint-disable no-useless-escape */
	/* eslint-disable import/no-webpack-loader-syntax */
	
	exports.default = Page;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-fixtures-js-b39038cb517dc1b66847.js